export default __webpack_public_path__ + "static/media/bandeira_ca.44f9e8bd.png";